import React, { createContext, useReducer, useContext } from "react";

const EventContext = createContext();

const initialState = {};

const EventReducer = (state, action) => {
    //console.log('EventReducer', state);
    if (action && action.resetState) {
        return { ...action };
    } else {
        return { ...state, ...action };
    }
};

const EventContextProvider = (p) => {

    const [state, dispatch] = useReducer(EventReducer, initialState);

    const eventDispatch = async (action) => {
        //console.log('EventContextProvider.eventDispatch', `action : ${(typeof action === "function")}`);
        if (typeof action === "function") {
            await action(dispatch, state);
        } else {
            dispatch(action);
        }
    };

    return (
        <EventContext.Provider value={{ state, eventDispatch: eventDispatch }}>
            {p.children}
        </EventContext.Provider>
    );
};

export const useEventContext = () => useContext(EventContext);
export default EventContextProvider;